// 控制 menu
export const defaultWidgetSet = {
  accessPointsOverview: {
    id: 'access-points-overview', check: false,
  },
  wirelessClientsRssi: {
    id: 'wireless-clients-rssi', check: false,
  },
  wirelessClientsBand: {
    id: 'wireless-clients-band', check: false,
  },
  top5WirelessClientsByTraffic: {
    id: 'top-5-wireless-clients-by-traffic', check: false,
  },
  top5SsidByTraffic: {
    id: 'top-5-ssid-by-traffic', check: false,
  },
  top5SwitchByTraffic: {
    id: 'top-5-switch-by-traffic', check: false,
  },
  top5ApByTraffic: {
    id: 'top-5-ap-by-traffic', check: false,
  },
  top5PoePower: {
    id: 'top-5-poe-power', check: false,
  },
  top5Cpu: {
    id: 'top-5-cpu', check: false,
  },
  top5Memory: {
    id: 'top-5-memory', check: false,
  },
  wirelessTrafficUsage: {
    id: 'wireless-traffic-usage', check: false,
  },
  apChannelUtilization: {
    id: 'ap-channel-utilization', check: false,
  },
  top5AccessPointsByWirelessClient: {
    id: 'top-5-access-points-by-wireless-client', check: false,
  },
  poePower: {
    id: 'poe-power', check: false,
  },
  wirelessClientsActivities: {
    id:'wireless-clients-activities', check: false,
  }
};

// 控制 card 位置
export const defaultWidgetCard = [
  {
    i: 'network-status',
    w: 3, h: 24, x: 0, y: 0, visible: true,
  },
  {
    i: 'access-points-overview',
    w: 1, h: 21, x: 0, y: 24, visible: true,
  },
  {
    i: 'wireless-clients-rssi',
    w: 1, h: 21, x: 1, y: 24, visible: true,
  },
  {
    i: 'wireless-clients-band',
    w: 1, h: 21, x: 2, y: 24, visible: true,
  },
  {
    i: 'top-5-wireless-clients-by-traffic',
    w: 1, h: 21, x: 0, y: 45, visible: true,
  },
  {
    i: 'top-5-switch-by-traffic',
    w: 1, h: 21, x: 1, y: 45, visible: true,
  },
  {
    i: 'top-5-ap-by-traffic',
    w: 1, h: 21, x: 2, y: 45, visible: true,
  },
  {
    i: 'wireless-traffic-usage',
    w: 3, h: 24, x: 0, y: 66, visible: true,
  },
  {
    i: 'ap-channel-utilization',
    w: 3, h: 24, x: 0, y: 90, visible: true,
  },
  {
    i: 'top-5-poe-power',
    w: 1, h: 21, x: 0, y: 114, visible: true,
  },
  {
    i: 'top-5-cpu',
    w: 1, h: 21, x: 1, y: 114, visible: true,
  },
  {
    i: 'top-5-memory',
    w: 1, h: 21, x: 2, y: 114, visible: true,
  },
  {
    i: 'top-5-ssid-by-traffic',
    w: 1, h: 21, x: 0, y: 135, visible: true,
  },
  {
    i: 'top-5-access-points-by-wireless-client',
    w: 1, h: 21, x: 1, y: 135, visible: true,
  },
  {
    i: 'poe-power',
    w: 1, h: 21, x: 2, y: 135, visible: true,
  },
  {
    i: 'wireless-clients-activities',
    w: 3, h: 24, x: 0, y: 156, visible: true,
  },
]

export const defaultActionStatus = {
  draggable: false,
  update: {
    system: false,
    custom: false,
  },
  reset: {
    system: false,
    custom: false,
  },
};

export const networkWidgetIds = [
  "network-status",
  "access-points-overview",
  "wireless-clients-rssi",
  "wireless-clients-band",
  "top-5-wireless-clients-by-traffic",
  "top-5-ssid-by-traffic",
  "top-5-switch-by-traffic",
  "top-5-ap-by-traffic",
  "top-5-poe-power",
  "top-5-cpu",
  "top-5-memory",
  "top-5-access-points-by-wireless-client",
  "wireless-traffic-usage",
  "ap-channel-utilization",
  "poe-power",
  "wireless-clients-activities"
];

export const defaultTimeRanges = {
  "1d": { label: "Last 24 Hours", value: "1d" },
  "1w": { label: "Last 7 days", value: "1w" },
}

export const defaultTimeRangeOptions = [
  defaultTimeRanges["1d"],
  defaultTimeRanges["1w"],
];